import axios from "axios";

export const webApi = axios.create({
  baseURL: process.env.REACT_APP_SERVER,
  headers: {
    "Content-Type": "application-json",
  },
});

export const emailsApi = axios.create({
  baseURL: process.env.REACT_APP_EMAIL,
  headers: {
    "Content-Type": "application-json",
  },
});
